module.exports = {
    BrandDetails: [
        {
            brand: "Samsung",
            offers: [
                {
                    "discount": "5%",
                    "valid_until": "2025-10-12",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },

                {
                    "discount": "10%",
                    "valid_until": "2025-01-12",
                    "Policy": [
                        "Only applicationon Galaxy series",
                        "Not valid on trade-ins",
                        "Limited to first 100 customers",

                    ]
                },
            ]
        },
        {
            brand: "MI",
            offers: [
                {
                    "discount": "5%",
                    "valid_until": "2025-01-12",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        // "One-time use per user.",

                    ]
                },
                {
                    "discount": "15%",
                    "valid_until": "2025-02-16",
                    "Policy": [
                        "Valid on Selected MI series.",
                        "Can't combine with sales items",
                    ]
                },
                {
                    "discount": "25%",
                    "valid_until": "2025-02-16",
                    "Policy": [
                        "Applicable on orders over $200",

                    ]
                },
            ]
        },
        {
            brand: "Apple",
            offers: [
                {

                    "discount": "20%",
                    "valid_until": "2025-02-16",
                    "Policy": [
                        "Valid on iPhone models",
                        "Not combinable with financing",
                        "single user only.",

                    ]
                },
                {

                    "discount": "25%",
                    "valid_until": "2025-02-16",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",


                    ]
                },
                {
                    "name": "Apple",
                    "discount": "15%",
                    "valid_until": "2025-03-16",
                    "Policy": [
                        "For iPad purchases only",
                        "Valid Online only",
                        "No other discounts apply"


                    ]
                },
            ],
        },
        {
            brand: "Motorola",
            offers: [
                {

                    "discount": "20%",
                    "valid_until": "2025-03-16",
                    "Policy": [
                        "Applicable on Mototola 9 and ablve.",
                        "Single-use per customer"
                    ]
                },
                {

                    "discount": "10%",
                    "valid_until": "2025-03-10",
                    "Policy": [
                        "Valid on New models only",
                        "Online purchases only"

                    ]
                },
            ]
        },
        {
            brand: "Vivo", offers: [
                {

                    "discount": "5%",
                    "valid_until": "2025-02-02",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {

                    "discount": "15%",
                    "valid_until": "2025-03-02",
                    "Policy": [
                        "Valid on Selected models.",



                    ]
                },
            ]
        },

        {
            brand: "Realme", offers: [
                {

                    "discount": "25%",
                    "valid_until": "2025-04-10",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {

                    "discount": "5%",
                    "valid_until": "2025-02-10",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",
                    ]
                },
            ],
        },
        {
            brand: "Adidas",
            offers: [
                {
                    "name": "adidas",
                    "discount": "12%",
                    "valid_until": "2025-05-11",
                    "Policy": [
                        "Applicable to selected items",
                        "can't combine with ther discounts. ",
                        "One per user.",
                    ]
                },
                {
                    "name": "adidas",
                    "discount": "20%",
                    "valid_until": "2025-05-29",
                    "Policy": [
                        "For online purchase Only",
                        "Not valid on sale items",
                        "One-time use per user"

                    ]
                },
            ],
        },
        {
            brand: "Nike", offers: [
                {
                    "name": "Nike",
                    "discount": "20%",
                    "valid_until": "2025-04-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Nike",
                    "discount": "10%",
                    "valid_until": "2025-03-19",
                    "Policy": [
                        "Valid on Selected items.",
                        "Cannot be combined with other offers.",
                        "One-time use per customer",
                        "Minimum purchase of $100"

                    ]
                },
            ],
        },
        {
            brand: "UnderArmour", offers: [
                {
                    "name": "Under Armour",
                    "discount": "15%",
                    "valid_until": "2025-03-21",
                    "Policy": [
                        "Valid on active wear only",
                        "Online only",
                        "Not combinable with other offers"

                    ]
                },
                {
                    "name": "Under Armour",
                    "discount": "20%",
                    "valid_until": "2025-01-20",
                    "Policy": [
                        "Applicable on all items above $100.",
                        "Limited to 1 per user",
                        "Valid for in-store purchases",

                    ]
                },
            ],
        },
        {
            brand: "Woodland", offers: [
                {
                    "name": "woodland",
                    "discount": "10%",
                    "valid until": "2025-01-29",
                    "Policy": [
                        "Valid on active wear only",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "woodland",
                    "discount": "15%",
                    "valid_until": "2025-03-30",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",


                    ]
                },
            ],
        },

        {
            brand: "Bata", offers: [
                {
                    "name": "Bata",
                    "discount": "15%",
                    "valid_until": "2025-02-30",
                    "Policy": [
                        "Valid on Selected models.",

                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Bata",
                    "discount": "25%",
                    "valid_until": "2025-02-26",
                    "Policy": [
                        "Valid on Selected models.",
                        "One-time use per customer",
                        "Minimum purchase of $100"

                    ]
                },
            ],
        },

        {
            brand: "Reebok", offers: [
                {
                    "name": "Reebok",
                    "discount": "25%",
                    "valid_until": "2025-02-26",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Reebok",
                    "discount": "25%",
                    "valid_until": "2025-02-18",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },

        {
            brand: "Converse", offers: [
                {
                    "name": "Converse",
                    "discount": "15%",
                    "valid_until": "2025-01-18",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Converse",
                    "discount": "25%",
                    "valid_until": "2025-03-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },
        {
            brand: "Puma", offers: [
                {
                    "name": "Puma",
                    "discount": "15%",
                    "valid_until": "2025-03-10",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Puma",
                    "discount": "25%",
                    "valid_until": "2025-03-15",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },
        {
            brand: "Hp", offers: [
                {

                    "discount": "15%",
                    "valid_until": "2025-03-14",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {

                    "discount": "25%",
                    "valid_until": "2025-03-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },

        {
            brand: "Dell", offers: [
                {
                    "name": "Dell",
                    "discount": "15%",
                    "valid_until": "2025-05-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Dell",
                    "discount": "25%",
                    "valid_until": "2025-06-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },
        {
            brand: "Lenovo", offers: [
                {
                    "name": "Lenovo",
                    "discount": "10%",
                    "valid_until": "2025-05-15",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "Lenovo",
                    "discount": "16%",
                    "valid_until": "2025-05-29",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },

        {
            brand: "Acer", offers: [
                {
                    "name": "acer",
                    "discount": "20%",
                    "valid_until": "2025-05-20",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "acer",
                    "discount": "12%",
                    "valid_until": "2025-04-10",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },
        {
            brand: "Asus", offers: [
                {
                    "name": "asus",
                    "discount": "20%",
                    "valid_until": "2025-04-22",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
                {
                    "name": "asus",
                    "discount": "20%",
                    "valid_until": "2025-03-25",
                    "Policy": [
                        "Valid on Selected models.",
                        "No cashback with this offer.",
                        "One-time use per user.",

                    ]
                },
            ],
        },

        {
            brand: "MackAir", offers: [
                {
                    "name": "MacBook Air",
                    "discount": "12%",
                    "valid_until": "2025-03-25",
                    "Policy": [
                        "Valid on Selected models.",
                        "available only for above 11",
                        "Online only.",
                    ]
                },
            ]

        }
    ]
};